import React from 'react';
import { Link } from 'react-router-dom';

import LocalText from '../localization/local_text';

import './css/not_found.scss';

function NotFound() {
  return (
    <div id="NotFound" className="notfound">
      <div className="notfound_box">
        <div className="notfound_box_imgWrap">
          <img className="img" src={require('../assets/images/icon/ico_error.svg').default} alt="PAGE NOT FOUND" />
        </div>
        <div className="notfound_box_textWrap">
          <p className="title">
            <LocalText txt={'notfound_subtitle'} />
          </p>
          <p className="text">
            <LocalText txt={'notfound_text'} />
          </p>
        </div>
      </div>
      <Link to="/" className="notfound_btnWrap">
        <LocalText txt={'notfound_gohome'} />
      </Link>
    </div>
  );
}

export default NotFound;
